import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var StyledKFolderBrowse = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "showFolderCover"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, showFolderCover = _a.showFolderCover;
    return (_b = {
            listStyle: "none",
            padding: 0,
            margin: 0,
            display: "grid",
            gap: theme.spacing(1),
            alignItems: "stretch",
            gridTemplateColumns: "repeat(auto-fill, minmax(".concat(showFolderCover ? "20em" : "18em", ", 1fr))")
        },
        _b[theme.breakpoints.down("sm")] = {
            gridTemplateColumns: "auto"
        },
        _b);
});

export { StyledKFolderBrowse as default };
//# sourceMappingURL=index.styled.js.map
